import { request, endpoints } from '../../utils'

export function signInAPI(data) {
  return request.post(endpoints.login, data)
}

export function getProfileAPI() {
  return request.get(`${endpoints.authenticate}`)
}
